/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Container from 'fierry/data/container';


export default class Collection extends Container
{
  constructor (type, cursor, parent)
  {
    super(cursor);

    this.type = type;
    this.parent = parent;
  }


  load (key, cass)
  {
    return this.type.load(this.cursor.child(key), cass, this.parent);
  }


  at (key)
  {
    return this.type.at(this.cursor.child(key), this.parent);
  }


};
